define(function() {
    return {
        name: "confirm",
        apply: function($element) {

            if($element.prop("tagName").toLowerCase() == 'a') {
                $element.on("click", function(ev) {
                    ev.preventDefault();
                    let message = $(this).data('action') +" "+$(this).data('name')+". This action cannot be undone. Are you sure?";
                    if ($(this).data('confirm-message') !== undefined) {
                        message = $(this).data('confirm-message');
                    }
                    if (window.confirm(message)) {
                        window.location.href = $(this).data("href");
                    }
                });
            }

            if($element.prop("tagName").toLowerCase() == 'button') {
                $element.on("click", function(ev) {
                    ev.preventDefault();
                    let message = $(this).data('action') +" "+$(this).data('name')+". This action cannot be undone. Are you sure?";
                    if ($(this).data('confirm-message') !== undefined) {
                        message = $(this).data('confirm-message');
                    }
                    if (window.confirm(message)) {
                        if($(this).data('form')){
                            $("#"+$(this).data('form')).submit();
                        }else{
                           $(this).parent('form').submit();
                        }
                    }
                });
            }
        }
    };
});
